<template>
  <BaseDialog
    :isOpen="isOpen"
    :title="title"
    @close="$emit('close')"
    @cancel="$emit('cancel')"
    @confirm="onConfirm"
    :hidePrimaryBtn="!canEdit"
  >
    <v-form :readonly="!canEdit" lazy-validation ref="upsertReservationDialog">
      <v-card-text>
        <p class="mb-2 text-subtitle-1">Thông tin cơ bản</p>
        <div class="pl-2">
          <autocomplete-student
            v-model="formData.student"
            label="Tìm kiếm học sinh"
            dense
            return-object
            class="pt-4"
            :rules="[$rules.required]"
            v-if="!isEdit && !fixedStudent"
          />
          <date-selector
            :disabled="!canEdit"
            label="Ngày hoàn thành thủ tục bảo lưu"
            :date="transformDateForDatePicker(formData.process_completion_date)"
            @change="onCompletionDateChange"
          ></date-selector>
          <date-selector
            :disabled="!canEdit"
            label="Ngày bắt đầu"
            :rules="[$rules.required]"
            :date="transformDateForDatePicker(formData.start_date)"
            @change="onStartDateChange"
          ></date-selector>
          <date-selector
            :disabled="!canEdit"
            label="Ngày kết thúc"
            :date="transformDateForDatePicker(formData.end_date)"
            @change="onEndDateChange"
          ></date-selector>
          <date-selector
            :disabled="!canEdit"
            label="Ngày quay lại dự kiến"
            :date="transformDateForDatePicker(formData.return_date)"
            @change="onReturnDateChange"
          ></date-selector>
          <v-select
            :items="reasonTypeOptions"
            item-value="value"
            item-title="text"
            v-model="formData.reason_type"
            label="Lí do nghỉ"
          >
          </v-select>
          <v-text-field label="Lí do khác" v-model="formData.reason"></v-text-field>
          <!-- <date-selector
          :disabled="!canEdit"
          label="Ngày vào học lớp mới"
          :date="transformDateForDatePicker(formData.new_class_date)"
          @change="onNewClassDateChange"
          ></date-selector> -->
          <v-select
            label="Trạng thái học phí"
            :items="tuitionStatusOptions"
            item-value="value"
            item-title="text"
            v-model="formData.tuition_status"
          >
          </v-select>
          <!-- <v-select
          label="Phương thức thanh toán"
            :items="getPaymentMethodOptions"
            item-value="value"
            item-title="text"
            v-model="formData.payment_method"
            >
          </v-select> -->
          <v-textarea rows="3" label="Ghi chú" v-model="formData.note"></v-textarea>
        </div>

        <p class="mt-3 mb-2 text-subtitle-1">Thông tin bổ sung</p>
        <div class="pl-2">
          <date-selector
            :disabled="!canEdit"
            label="Đã quay lại vào ngày"
            :date="transformDateForDatePicker(formData.actual_return_date)"
            @change="onActualReturnDateChange"
          ></date-selector>
          <v-text-field label="Lớp học khi quay lại" v-model="formData.new_class"></v-text-field>
        </div>
      </v-card-text>
    </v-form>
  </BaseDialog>
</template>
<script>
import BaseDialog from '@/components/base/BaseDialog'
import DateSelector from '@/components/basic/DateSelector.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import {
  getPaymentMethodOptions,
  reasonTypeOptions,
  transformDateForDatePicker,
  tuitionStatusOptions
} from '../helpers'

export default {
  components: {
    DateSelector,
    AutocompleteStudent,
    BaseDialog
  },
  data() {
    return {
      formData: cloneDeep(this.currentItem)
    }
  },
  props: {
    currentItem: Object,
    isOpen: Boolean,
    isEdit: Boolean,
    fixedStudent: Boolean
  },
  computed: {
    getPaymentMethodOptions,
    reasonTypeOptions,
    tuitionStatusOptions,
    ...mapState('auth', ['profile', 'role']),
    canEdit() {
      return ['super_admin', 'education_manager'].includes(this.role.type)
    },

    title() {
      if (this.isEdit) {
        return 'Cập nhật bảo lưu'
      }
      return 'Tạo mới bảo lưu'
    }
  },
  methods: {
    transformDateForDatePicker,
    onCompletionDateChange(value) {
      this.formData.process_completion_date = moment(value, 'YYYY-MM-DD').toISOString()
    },
    onStartDateChange(value) {
      this.formData.start_date = moment(value, 'YYYY-MM-DD').toISOString()
    },
    onEndDateChange(value) {
      this.formData.end_date = moment(value, 'YYYY-MM-DD').endOf('day').toISOString()
    },
    onReturnDateChange(value) {
      this.formData.return_date = moment(value, 'YYYY-MM-DD').endOf('day').toISOString()
    },
    onActualReturnDateChange(value) {
      this.formData.actual_return_date = moment(value, 'YYYY-MM-DD').endOf('day').toISOString()
    },
    onNewClassDateChange(value) {
      this.formData.new_class_date = moment(value, 'YYYY-MM-DD').endOf('day').toISOString()
    },
    formatDateField(v) {
      if (!v) {
        return v
      }
      return moment(v).format('DD/MM/YYYY')
    },
    onConfirm() {
      if (this.$refs.upsertReservationDialog.validate()) {
        this.$emit('confirm', this.formData)
      }
    }
  }
}
</script>
